import React from 'react';
import PropTypes from 'prop-types';

const UploadIcon = ({ fill = 'var(--PRIMARY)' }) => (
  <svg
    width="9"
    height="14"
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.89119 0.190147L4.78849 0.118547L4.68019 0.063695L4.60251 0.0359402L4.52296 0.0160437L4.44192 0.00401211C4.38709 -0.00139332 4.33179 -0.00139332 4.2769 0.00401688L4.21069 0.0134563L4.11613 0.0360117L4.00163 0.0805826L3.90945 0.131121L3.82769 0.190144L3.77173 0.240418L0.245665 3.76638C-0.0817194 4.09376 -0.0817194 4.62458 0.245665 4.95196L0.313732 5.01307C0.642918 5.27789 1.12569 5.25752 1.43124 4.95196L3.5216 2.86225L3.52113 9.89215C3.52113 10.3551 3.89646 10.7305 4.35945 10.7305L4.44516 10.7261C4.86789 10.6832 5.19777 10.3262 5.19777 9.89215L5.19826 2.86292L7.28763 4.95196C7.61502 5.27934 8.14583 5.27934 8.47321 4.95196C8.8006 4.62458 8.8006 4.09376 8.47321 3.76638L4.95196 0.245148C4.92176 0.21604 4.92176 0.21604 4.89119 0.190147Z"
      fill={fill}
    />
    <path
      d="M0.838483 14L7.88043 14C8.34342 14 8.71875 13.6247 8.71875 13.1617C8.71875 12.6987 8.34342 12.3233 7.88043 12.3233H0.838459C0.375465 12.3233 0.000139236 12.6987 0.000139236 13.1617C0.000139236 13.6246 0.375489 14 0.838483 14Z"
      fill={fill}
    />
  </svg>
);

UploadIcon.propTypes = {
  fill: PropTypes.string,
};

export default UploadIcon;
